import React, { useState, useEffect } from "react";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  editDisciplinaryActions,
  saveDisciplinaryActions,
} from "../../redux/Modulo_Sanciones/Disciplinary_Actions/actions";
// import {
//   getDisciplinaryCase,
//   getDisciplinaryCases,
// } from "../../redux/Modulo_Sanciones/diciplinarycase/actions";

const DisciplinaryCaseModal = (props) => {
  const [validated, setValidated] = useState(false);
  const { saveLoading, formError } = useSelector(
    (store) => store.disciplinaryActions
  );
  const {
    loaderDiciplinaryCases,
    disciplinaryCases,
    disciplinaryCasesFaild,
    disciplinaryCase,
  } = useSelector((store) => store.disciplinaryCase);

  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = {
      casoDis: e.target.casoDis.value,
    };

    if (!props.edit) {
      dispatch(saveDisciplinaryActions(req));
      e.target.reset();
      props.handleClose();
    } else {
      dispatch(editDisciplinaryActions(req, props.editItem.id, props.index));
      props.handleClose();
    }
  };

  return (
    <>
      <Modal show={props.show} onHide={() => props.handleClose()}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title className="text-muted">Caso disciplinario</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formError}
              </Alert>
            )}
            {!!disciplinaryCasesFaild && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {disciplinaryCasesFaild}
              </Alert>
            )}
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Caso disciplinario activo
              </Form.Label>
              <Row>
                <Col sm={loaderDiciplinaryCases ? "10" : "12"}>
                  <Form.Control
                    name="casoDis"
                    className="rounded-pill"
                    required
                    disabled
                    type="text"
                    defaultValue={
                      props.editItem.list_caso_disciplinario
                        ? props.editItem.list_caso_disciplinario[0]
                            .caso_disciplinario
                        : null
                    }
                    // onChange={(e) => {
                    //   if (e.currentTarget.value) {
                    //     dispatch(
                    //       getDisciplinaryCase(parseInt(e.currentTarget.value))
                    //     );
                    //   }
                    // }}
                    placeholder="Caso disciplinario activo"
                  >
                    {/* <option value="" selected disabled></option>
                    {disciplinaryCases && disciplinaryCases.data
                      ? disciplinaryCases.data.map((item) => (
                          <option
                            key={item.id}
                            value={item && item.id ? item.id : null}
                            disabled
                          >
                            {item.nombre ? item.nombre.toUpperCase() : ""}
                          </option>
                        ))
                      : null} */}
                  </Form.Control>
                </Col>
                {loaderDiciplinaryCases && (
                  <Col sm="2">
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Tipo de acción disciplinaria
              </Form.Label>
              <Form.Control
                name="disciplinaryActionType"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario &&
                  props.editItem.list_caso_disciplinario[0]
                    .list_accion_disciplinaria
                    ? props.editItem.list_caso_disciplinario[0]
                        .list_accion_disciplinaria[0].nombre
                    : null
                }
                placeholder="Tipo de acción disciplinaria"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Creado por
              </Form.Label>
              <Form.Control
                name="createdBy"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario &&
                  props.editItem.list_caso_disciplinario[0].list_creado_por
                    ? props.editItem.list_caso_disciplinario[0]
                        .list_creado_por[0].first_name +
                      " " +
                      props.editItem.list_caso_disciplinario[0]
                        .list_creado_por[0].last_name
                    : null
                }
                placeholder="Creado por"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Encargado
              </Form.Label>
              <Form.Control
                name="userInCharge"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario &&
                  props.editItem.list_caso_disciplinario[0].list_id_encargado
                    ? props.editItem.list_caso_disciplinario[0]
                        .list_id_encargado[0].first_name +
                      " " +
                      props.editItem.list_caso_disciplinario[0]
                        .list_id_encargado[0].last_name
                    : null
                }
                placeholder="Encargado"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Fecha de vencimiento
              </Form.Label>
              <Form.Control
                name="fechaVenc"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario &&
                  props.editItem.list_caso_disciplinario[0].fecha_vencimiento
                    ? props.editItem.list_caso_disciplinario[0]
                        .fecha_vencimiento
                    : null
                }
                placeholder="Fecha de vencimiento"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Estatus
              </Form.Label>
              <Form.Control
                name="estatus"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario &&
                  props.editItem.list_caso_disciplinario[0].list_estatus
                    ? props.editItem.list_caso_disciplinario[0].list_estatus[0]
                        .nombre
                    : null
                }
                placeholder="Estatus"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Numero de ticket
              </Form.Label>
              <Form.Control
                name="numTicket"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  props.editItem.list_caso_disciplinario
                    ? props.editItem.list_caso_disciplinario[0].numero_ticket
                    : null
                }
                placeholder="Numero de ticket"
              ></Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => props.handleClose()}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default DisciplinaryCaseModal;
